import UploadSelfie from './UploadSelfie';

export default UploadSelfie;
